export const SAVE = 'stepWhatHappened.SAVE';
export const VALUE_CHANGED = 'stepWhatHappened.VALUE_CHANGED';
export const LOAD = 'stepWhatHappened.VALUE_LOAD';
export const RESET = 'stepWhatHappened.RESET';
export const RESET_CLAIM_TO_INJURY = 'stepWhatHappened.RESET_CLAIM_TO_INJURY';
export const RESET_DETAIL_OF_MEDICAL_CONDITIONAL = 'stepWhatHappened.RESET_DETAIL_OF_MEDICAL_CONDITIONAL';
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const GET_COUNTRY_LIST_SUCCESS = 'GET_COUNTRY_LIST_SUCCESS';
export const GET_CITY_LIST = 'GET_CITY_LIST';
export const GET_CITY_LIST_SUCCESS = 'GET_CITY_LIST_SUCCESS';
export const GET_CLAIM_TYPES = 'GET_CLAIM_TYPES';
export const GET_CLAIM_TYPES_SUCCESS = 'GET_CLAIM_TYPES_SUCCESS';
export const VALIDATE_DATE_TIME_OF_EVENT = 'VALIDATE_DATE_TIME_OF_EVENT';
export const POLICY_VERSION_CHANGED = 'POLICY_VERSION_CHANGED';
export const GET_COUNTRY_SUPPORTED_LIST = 'GET_COUNTRY_SUPPORTED_LIST';
export const GET_COUNTRY_SUPPORTED_LIST_SUCCESS = 'GET_COUNTRY_SUPPORTED_LIST_SUCCESS';
export const RESET_FILES_BY_BENEFIT_CODE = 'RESET_FILES_BY_BENEFIT_CODE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepWhatHappened/constants.js